import React, { useState, useEffect } from 'react';

const JoinRoomModal = ({ onClose, onJoin, error, initialRoomId }) => {
  const [roomId, setRoomId] = useState(initialRoomId || '');
  const [roomKey, setRoomKey] = useState('');
  const [localError, setError] = useState('');
  //console.log(initialRoomId);
  useEffect(() => {
    setRoomId(initialRoomId || ''); // Update roomId if parent changes it
  }, [initialRoomId]);

  useEffect(() => {
    if (error) {
      setError(error);
    }
  }, [error]);

  const handleJoin = () => {
    if (!roomId.trim()) {
      setError('Room ID is required');
      return;
    }

    onJoin({ roomId, roomKey });
    onClose();
  };

return (
    <div className="fixed inset-0 p-4 sm:p-6 bg-black bg-opacity-60 flex items-center justify-center z-20">
      <div className="bg-yellow relative backdrop-blur-md rounded-xl w-full max-w-full sm:max-w-xl p-6 sm:p-8 shadow-xl transition-all duration-300 animate-fade-in text-black" >

        <div className="flex justify-end">
          <button
            onClick={onClose}
              className="relative w-10 h-10 flex items-center text-center justify-center text-3xl
                rounded-full bg-[#FF1111] shadow-[0_6px_0_#C30F0F] text-[#FFCC21] font-extrabold
                active:translate-y-[2px] active:shadow-none
                transition-all duration-200 ease-in-out
                hover:scale-[1.03]
                hover:brightness-110"
            >
            ✕
          </button>
        </div>
        
        <h2 className="text-3xl font-bold text-center mb-4">Join Game</h2>
  
        {localError && <p className="text-black-500 mb-4 text-sm text-center">{localError}</p>}
      
        {/* Only show Room ID input if not passed from parent */}
        {!initialRoomId && (
          <>
          <div className="text-left mb-4">
            <label className="block text-sm font-medium mb-1 roboto-f">Game ID:</label> 
            <input
              className="w-full py-2 px-4 rounded-full bg-white shadow-[0px_4px_6px_rgba(0,0,0,0.25)] border border-[#FFA600] focus:outline-none focus:ring-2 focus:ring-indigo-500"
              value={roomId}
              onChange={(e) => setRoomId(e.target.value)}
              placeholder="Enter Room ID"
            />
          </div>
          </>
        )}
  
        <div className="text-left mb-6">
          <label className="block text-sm font-medium mb-1 roboto-f">Game Key (if private):</label>
          <input
            className="w-full py-2 px-4 rounded-full bg-white shadow-[0px_4px_6px_rgba(0,0,0,0.25)] border border-[#FFA600] focus:outline-none focus:ring-2 focus:ring-indigo-500"
            value={roomKey}
            onChange={(e) => setRoomKey(e.target.value)}
            placeholder="Optional Room Key"
          />
        </div>

        <div className="flex justify-center">
          <button
            className="font-bold relative inline-block px-4 sm:px-6 py-2 sm:py-3 text-white font-bold text-base sm:text-lg 
              bg-[#FF1111] rounded-2xl shadow-[0_6px_0_0_#C30F0F]
              transition-all duration-150 ease-in-out
              hover:scale-[1.03]
              hover:brightness-110
              active:translate-y-[4px] active:shadow-none"
                onClick={handleJoin}
            >
            Join
          </button>
        </div>

      </div>
    </div>
  );
  
};

export default JoinRoomModal;
